export default __webpack_public_path__ + "static/media/taiwanese-labor-landing.41f471cc.png";